export default "__VITE_ASSET__DqVzUoDl__"